<label class="checkbox-label">
  @if (!control) {
    <input class="checkbox" type="checkbox" [ngModel]="checked" (ngModelChange)="checked = $event; checkChanged()" />
  }
  @if (control) {
    <input class="checkbox" type="checkbox" [formControl]="control" (change)="checkChanged()" />
  }
  <span class="check-marker">
    <span class="mb-icon mb-icon-marked-ok-thin"></span>
  </span>
  <ng-content></ng-content>
</label>
